export function Loading({ message = 'Loading…', fullscreen = false }: { message?: string; fullscreen?: boolean }) {
  if (fullscreen) {
    return (
      <div className="centred">
        <div className="panel">
          <p style={{ marginBottom: 0 }}>{message}</p>
        </div>
      </div>
    );
  }
  return <div className="empty">{message}</div>;
}
